function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Col from "./Col";
import FormGroup from "./FormGroup";
import FormText from "./FormText";
import FormFeedback from "./FormFeedback";
import Label from "./Label";
import Required from "./Required";
var labelSizeTranslations = {
  sm: 2,
  md: 3,
  lg: 4
}; // Note:  `inline` has no effect at the moment.  In reactstrap 5 and later, this property appears
// to be relevant for the <FormGroup>, though.  As such, we may be able to simplify this class with
// the built-in support of inline forms in newer versions of reactstrap.

var FormLabelGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(FormLabelGroup, _React$Component);

  var _super = _createSuper(FormLabelGroup);

  function FormLabelGroup() {
    _classCallCheck(this, FormLabelGroup);

    return _super.apply(this, arguments);
  }

  _createClass(FormLabelGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          feedback = _this$props.feedback,
          inputId = _this$props.inputId,
          hint = _this$props.hint,
          label = _this$props.label,
          labelSize = _this$props.labelSize,
          required = _this$props.required,
          rowClassName = _this$props.rowClassName,
          size = _this$props.size,
          srLabel = _this$props.srLabel,
          stacked = _this$props.stacked,
          validFeedback = _this$props.validFeedback,
          width = _this$props.width;
      var containerClassNames = classnames({
        'is-invalid': feedback,
        'is-valid': validFeedback
      }, rowClassName);
      var labelClassNames = classnames({
        'text-sm-right pr-0': !stacked,
        'text-danger': feedback,
        'text-success': validFeedback,
        'sr-only sr-only-focusable': srLabel
      });
      var hiddenClassNames = classnames({
        'is-invalid': feedback,
        'is-valid': validFeedback
      }, 'form-control');
      var labelWidth = stacked ? 12 : labelSizeTranslations[labelSize || 'md'];
      var inputWidth = stacked || !label ? 12 : 12 - labelWidth;
      var valueWidth = stacked ? width : {
        xs: width.xs,
        sm: width.sm ? Math.min(inputWidth, width.sm) : inputWidth,
        md: width.md ? Math.min(inputWidth, width.md) : undefined,
        lg: width.lg ? Math.min(inputWidth, width.lg) : undefined,
        xl: width.xl ? Math.min(inputWidth, width.xl) : undefined
      };
      return /*#__PURE__*/React.createElement(FormGroup, {
        row: true,
        className: containerClassNames
      }, label && /*#__PURE__*/React.createElement(Label, {
        for: inputId,
        sm: labelWidth,
        size: size,
        className: labelClassNames
      }, label, required && label ? /*#__PURE__*/React.createElement(Required, null) : null), /*#__PURE__*/React.createElement(Col, valueWidth, children, (feedback || validFeedback) && /*#__PURE__*/React.createElement("div", {
        className: hiddenClassNames,
        hidden: true
      }), hint && /*#__PURE__*/React.createElement(FormText, {
        color: "muted"
      }, hint), feedback && /*#__PURE__*/React.createElement(FormFeedback, {
        className: "d-flex"
      }, feedback), validFeedback && /*#__PURE__*/React.createElement(FormFeedback, {
        className: "d-flex",
        valid: true
      }, validFeedback)));
    }
  }]);

  return FormLabelGroup;
}(React.Component);

FormLabelGroup.propTypes = {
  children: PropTypes.node.isRequired,
  feedback: PropTypes.node,
  hint: PropTypes.node,
  inline: PropTypes.bool,
  inputId: PropTypes.string,
  label: PropTypes.node,
  labelSize: PropTypes.oneOf([null, 'sm', 'md', 'lg']),
  required: PropTypes.bool,
  rowClassName: PropTypes.string,
  size: PropTypes.string,
  srLabel: PropTypes.bool,
  stacked: PropTypes.bool,
  validFeedback: PropTypes.node,
  width: PropTypes.object
};
FormLabelGroup.defaultProps = {
  inline: false,
  required: false,
  srLabel: false,
  stacked: false,
  width: {
    xs: 12
  }
};
FormLabelGroup.displayName = "FormLabelGroup";
export default FormLabelGroup;